export default {
  // Backend
  // + Services
  backendTrainingServices (state) {
    return state.trainingServices
  },
  // + Details
  backendTrainingServiceDetail (state) {
    return state.trainingServiceDetails
  },
  vnBackendTSTab: (state) => (url) => {
    const data = state.trainingServices.find(item => item.url === url && item.lang === 'vn')
    if (!data) {
      return state.blankTSData
    }
    return data
  },
  enBackendTSTab: (state) => (url) => {
    const data = state.trainingServices.find(item => item.url === url && item.lang === 'en')
    if (!data) {
      return state.blankTSData
    }
    return data
  },
  vnBackendTSDTab: (state) => (url) => {
    const data = state.trainingServiceDetails.find(item => item.url === url && item.lang === 'vn')
    if (!data) {
      return state.blankTSDData
    }
    return data
  },
  enBackendTSDTab: (state) => (url) => {
    const data = state.trainingServiceDetails.find(item => item.url === url && item.lang === 'en')
    if (!data) {
      return state.blankTSDData
    }
    return data
  },
  // showTSeDetails: (state) => (id) => {
  //   const data = state.trainingServices
  //     .find(item => item.id === id)
  //   return data.name
  // },
  selectTrainingServices: (state) => (lang) => {
    const data = state.trainingServices
      .filter(item => item.lang === lang && item.subMenus === true)
      .map(item => ({ id: item.id, name: item.name, routeName: item.routeName, url: item.url }))
    return data
  },
  //
  filterSubMenus2: (state, getters, rootState) => (id) => {
    if (rootState.lang === 'vn') {
      const data = state.trainingServices.filter(item => item.lang === 'vn')
      return data.filter(item => item.subMenuId === id)
    } else {
      const data = state.trainingServices.filter(item => item.lang === 'en')
      return data.filter(item => item.subMenuId === id)
    }
  },
  filterSubMenus3: (state, getters, rootState) => (id) => {
    return state.frontendTSD.filter(item => item.lang === rootState.lang && item.serviceId === id)
  },
  // findSubMenusDetails: (state, getters, rootState) => (url) => {
  //   if (rootState.lang === 'vn') {
  //     const vnDataDetails = state.trainingServiceDetails.filter(item => item.lang === 'vn')
  //     const vnData = state.trainingServices.filter(item => item.lang === 'vn')
  //     // ---
  //     const temp = vnDataDetails.filter(item => item.url === url)
  //     if (temp.length === 0) {
  //       const data = vnData.find(item => item.url === url)
  //       const finalId = vnData.find(item => item.url === url).subMenuId
  //       return [data, finalId]
  //     } else {
  //       const subId = temp[0].serviceId
  //       const finalId = vnData.find(item1 => item1.id === subId).subMenuId
  //       return [temp[0], finalId]
  //     }
  //   } else {
  //     const enDataDetails = state.trainingServiceDetails.filter(item => item.lang === 'en')
  //     const enData = state.trainingServices.filter(item => item.lang === 'en')
  //     // ---
  //     const temp = enDataDetails.filter(item => item.url === url)
  //     if (temp.length === 0) {
  //       const data = enData.find(item => item.url === url)
  //       const finalId = enData.find(item => item.url === url).subMenuId
  //       return [data, finalId]
  //     } else {
  //       const subId = temp[0].serviceId
  //       const finalId = enData.find(item1 => item1.id === subId).subMenuId
  //       return [temp[0], finalId]
  //     }
  //   }
  // },
  topTrainingServices (state, getters, rootState) {
    return state.homeTS.filter(item => item.lang === rootState.lang)
  },
  getDescriptionForTS (state, getters, rootState) {
    return state.descriptionsForTS.find(item => item.lang === rootState.lang)
  },
  getFrontendTS (state, getters, rootState) {
    return state.frontendTS.filter(item => item.lang === rootState.lang)
  },
  searchSectionTS (state, getters, rootState) {
    return state.trainingServices.filter(item => item.lang === rootState.lang && item.isHidden === false)
  }
  // getFrontendTSD (state, getters, rootState) {
  //   return state.frontendTSD.filter(item => item.lang === rootState.lang)
  // }
}
